export enum TableSortOrderEnum {
  Ascend = 'ascend',
  Descend = 'descend',
}
